// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getFileExtension from "@insite/client-framework/Common/Utilities/getFileExtension";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import batchLoadProducts from "@insite/client-framework/Store/Components/OrderUpload/Handlers/BatchLoadProducts";
import cleanupUploadData from "@insite/client-framework/Store/Components/OrderUpload/Handlers/CleanupUploadData";
import processFile from "@insite/client-framework/Store/Components/OrderUpload/Handlers/ProcessFile";
import setAllowCancel from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetAllowCancel";
import setErrorsModalIsOpen from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetErrorsModalIsOpen";
import setIsBadFile from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetIsBadFile";
import setIsUploading from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetIsUploading";
import setUploadCancelled from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetUploadCancelled";
import setUploadLimitExceeded from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetUploadLimitExceeded";
import translate from "@insite/client-framework/Translate";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";
// import Button, { ButtonPresentationProps } from "@insite/mobius/Button"; // Starter Custom Code
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
// import FileUpload, { FileUploadPresentationProps } from "@insite/mobius/FileUpload"; // Store Custom Code
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code */
import FormActions, { FormActionsStyles } from "@store/Library/Components/Toolkit/FormActions";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

/* Store Custom Code - Start */
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import getColor from "@insite/mobius/utilities/getColor";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import Download from "@store/Library/Components/Icons/Download";
import Upload from "@store/Library/Components/Icons/Upload";
import FileUpload, { FileUploadPresentationProps } from "@store/MobiusOverrides/FileUpload/FileUpload";
import { FormFieldIcon } from "@store/MobiusOverrides/FormField/FormField";
/* Store Custom Code - End */

export interface OwnProps {
    descriptionText: React.ReactNode;
    checkInventory: boolean;
    templateUrl: string;

    onUploadProducts: (products: ProductDto[]) => Promise<void>; // Store Custom Code
    extendedStyles?: OrderUploadStyles;
    /* Store Custom Code - Start */
    rowLimit?: number;
    warningLimit?: number;
    /* Store Custom Code - End */
}

const mapStateToProps = (state: ApplicationState) => ({
    uploadedItems: state.components.orderUpload.uploadedItems,
    isUploading: state.components.orderUpload.isUploading,
    products: state.components.orderUpload.products,
    rowErrors: state.components.orderUpload.rowErrors,
    isBadFile: state.components.orderUpload.isBadFile,
    failedToLoadInventory: state.components.orderUpload.failedToLoadInventory,
    productsProcessed: state.components.orderUpload.productsProcessed,
    allowCancel: state.components.orderUpload.allowCancel,
    uploadCancelled: state.components.orderUpload.uploadCancelled,
    uploadLimitExceeded: state.components.orderUpload.uploadLimitExceeded,
    continueUpload: state.components.orderUpload.continueUpload,
});

const mapDispatchToProps = {
    processFile,
    batchLoadProducts,
    cleanupUploadData,
    setAllowCancel,
    setIsBadFile,
    setIsUploading,
    setUploadCancelled,
    setUploadLimitExceeded,
    setErrorsModalIsOpen,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderUploadStyles {
    mainWrapper?: InjectableCss;
    orderCancellationSuccessfulText?: TypographyPresentationProps;
    uploadLinkTooltipText?: TypographyPresentationProps;
    downloadTemplateButton?: ButtonPresentationProps;
    fileUploader?: FileUploadPresentationProps;
    includeFirstRowCheckbox?: CheckboxProps;
    cancelUploadButton?: ButtonPresentationProps;
    uploadFileButton?: ButtonPresentationProps;
    spinner?: LoadingSpinnerProps;
    uploadingButtonLabel?: TypographyPresentationProps;
    uploadFileButtonLabel?: TypographyPresentationProps;
    // Starter Custom Code
    cancelMessage?: InfosBoxProps;
    // Foundation
    rowWrapper?: InjectableCss;
    // Store Custom Code
    formActions?: FormActionsStyles;
}

export const orderUploadStyles: OrderUploadStyles = {
    mainWrapper: {
        css: css`
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-top: 2em;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    orderCancellationSuccessfulText: {
        color: "warning",
        css: css`
            line-height: ${pxToRem(25)};
        `,
    },
    uploadLinkTooltipText: {
        css: css`
            margin-bottom: ${pxToRem(15)};
        `,
    },
    downloadTemplateButton: {
        icon: {
            src: Download,
            position: "left",
        },
        css: css`
            display: flex;
            align-items: center;
            margin-bottom: ${pxToRem(15)};

            > * {
                top: 0 !important;
            }
        `,
        variant: "tertiary",
    },
    includeFirstRowCheckbox: {
        css: css`
            margin: ${pxToRem(15)} 0;
            display: flex;
            align-items: center;
        `,
    },
    fileUploader: {
        /* Store Custom Code - Start */
        iconClickableProps: {
            css: css`
                &&&& {
                    height: ${pxToRem(48)};
                    width: ${pxToRem(48)};
                    > span {
                        height: ${pxToRem(48)};
                        width: ${pxToRem(48)};
                    }
                }
                    :hover {
                        && > ${FormFieldIcon} {
                            color: ${getColor("primary.dark")};
                        }
                    }
                    && > ${FormFieldIcon} {
                        > svg {
                            height: ${pxToRem(48)};
                            width: ${pxToRem(48)};
                        }
                        color: ${getColor("primary")};
                    }
                }
            `,
        },
        clearButtonClickableProps: {
            css: css`
                &&&& {
                    height: ${pxToRem(48)};
                    width: ${pxToRem(48)};
                }
                :hover {
                    && > ${FormFieldIcon} {
                        color: ${getColor("primary.dark")};
                    }
                }
            `,
        },
        clearIconProps: {
            size: 50,
            css: css`
                &&&& {
                    height: ${pxToRem(48)};
                    width: ${pxToRem(48)};
                }
                color: ${getColor("primary")};
            `,
        },
        /* Store Custom Code - End */
        buttonProps: {
            variant: "tertiary",
            css: css`
                margin: 1.8em 0 auto ${pxToRem(15)};
            `,
        },
    },
    cancelUploadButton: {
        variant: "secondary",
        /* Store Deleted Code */
    },
    uploadFileButton: {
        icon: {
            src: Upload,
            position: "left",
        },
        /* Store Deleted Code */
    },
    spinner: {
        size: 22,
        css: css`
            margin-right: ${pxToRem(8)};
        `,
    },
    uploadingButtonLabel: {
        css: css`
            font-size: ${pxToRem(15)};
            font-weight: bold;
            vertical-align: super;
        `,
    },
    uploadFileButtonLabel: {
        css: css`
            font-size: ${pxToRem(15)};
            font-weight: bold;
        `,
    },
    rowWrapper: {
        css: css`
            margin-bottom: 2em;
        `,
    },
};

const styles = orderUploadStyles;

const OrderUpload: FC<Props> = ({
    descriptionText,
    checkInventory,
    templateUrl,
    uploadedItems,
    isUploading,
    products,
    rowErrors,
    isBadFile,
    failedToLoadInventory,
    productsProcessed,
    allowCancel,
    uploadCancelled,
    uploadLimitExceeded,
    continueUpload,
    processFile,
    onUploadProducts,
    batchLoadProducts,
    cleanupUploadData,
    setAllowCancel,
    setIsBadFile,
    setIsUploading,
    setUploadCancelled,
    setErrorsModalIsOpen,
    /* Store Custom Code - Start */
    rowLimit = 500,
    warningLimit = 50,
    /* Store Custom Code - End */
}) => {
    const toasterContext = useContext(ToasterContext);
    const fileUploadRef = useRef({ value: "" } as HTMLInputElement);

    const [file, setFile] = useState<any>(null);
    const [incorrectFileExtension, setIncorrectFileExtension] = React.useState(false);
    const [firstRowHeading, setFirstRowHeading] = React.useState(true);
    const firstRowHeadingChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        setFirstRowHeading(value);
    };
    /* Starter Custom Code - Start */
    const trackAddToCart = ga.use.trackAddToCart(); // Starter Custom Code
    const trackStartQuickOrderListUpload = ga.use.trackStartQuickOrderListUpload();
    const trackQuickOrderListItemsUploaded = ga.use.trackQuickOrderListItemsUploaded();
    const trackQuickOrderTemplateDownloaded = ga.use.trackQuickOrderTemplateDownloaded();
    const trackCancelQuickOrderListUpload = ga.use.trackCancelQuickOrderListUpload();
    /* Starter Custom Code - End */

    /* Store Custom Code - Start */
    const history = useHistory();
    const cartPageUrl = useAppSelector(state => getPageLinkByPageType(state, "CartPage")?.url) || "Cart";
    /* Store Custom Code - End */

    React.useEffect(() => batchGetProducts(), [uploadedItems]);

    React.useEffect(() => checkCompletion(), [productsProcessed]);

    React.useEffect(() => {
        if (isBadFile || uploadLimitExceeded || failedToLoadInventory) {
            setErrorsModalIsOpen({ errorsModalIsOpen: true });
        }
        if (failedToLoadInventory) {
            cancelUploadingHandler();
        }
    }, [isBadFile, uploadLimitExceeded, failedToLoadInventory]);

    const downloadTemplateHandler = () => {
        trackQuickOrderTemplateDownloaded(); // Starter Custom Code
        window.open(`${window.location.origin}${templateUrl}`);
    };

    const cancelUploadingHandler = () => {
        setUploadCancelled({ uploadCancelled: true });
        setIsUploading({ isUploading: false });
        cleanupUploadData();
        setFile(null);
        if (fileUploadRef.current?.value) {
            fileUploadRef.current.value = "";
        }
        setFirstRowHeading(false);
        trackCancelQuickOrderListUpload(); // Starter Custom Code
    };

    const uploadFileHandler = () => {
        if (isUploading) {
            return;
        }

        setUploadCancelled({ uploadCancelled: false });
        if (!file) {
            return;
        }

        trackStartQuickOrderListUpload(); // Starter Custom Code
        const reader = new FileReader();
        reader.onload = onReaderLoad(getFileExtension(file.name));
        reader.readAsArrayBuffer(file);
    };

    const onReaderLoad = (fileExtension: string) => {
        return (e: Event) => {
            const data = (e.target as any).result;
            processFile({ data, fileExtension, firstRowHeading, rowLimit }); // Store Custom Code - added rowLimit
        };
    };

    const batchGetProducts = () => {
        cleanupUploadData();
        if (!file) {
            return;
        }

        if (uploadedItems.length === 0) {
            setIsBadFile({ isBadFile: true });
            return;
        }

        const extendedNames = uploadedItems.map(item => item.name);
        batchLoadProducts({ extendedNames, firstRowHeading, checkInventory });
    };

    const checkCompletion = React.useCallback(() => {
        if (!productsProcessed || uploadCancelled) {
            return;
        }

        if (uploadedItems.length === products.length && rowErrors.length === 0) {
            uploadProducts();
        } else {
            setIsUploading({ isUploading: false });
            setErrorsModalIsOpen({ errorsModalIsOpen: true });
        }
    }, [productsProcessed, uploadCancelled, uploadedItems, products, rowErrors]);

    const uploadProducts = async () => {
        setAllowCancel({ allowCancel: false });
        /* Store Custom Code - Start */
        if (products.length >= warningLimit) {
            toasterContext.addToast({
                body: siteMessage("OrderUpload_Warning_LargeUpload"),
                messageType: "warning",
            });
        }
        setIsUploading({ isUploading: true });
        await onUploadProducts(products);
        setIsUploading({ isUploading: false });
        /* Store Custom Code - End */
        onUploadingSuccess();
    };

    const onUploadingSuccess = React.useCallback(() => {
        setIsUploading({ isUploading: false });
        cleanupUploadData();
        trackQuickOrderListItemsUploaded(); // Starter Custom Code
        trackAddToCart({ items: products }); // Starter Custom Code
        toasterContext.addToast({ body: `${products.length} ${translate("items uploaded")}`, messageType: "success" });
        /* Store Custom Code - Start */

        history.push(cartPageUrl);
        /* Store Custom Code - End */
    }, [products]);

    React.useEffect(() => {
        if (continueUpload) {
            uploadProducts();
        }
    }, [continueUpload]);

    const fileChangeHandler = (event: React.ChangeEvent<any>) => {
        const uploadedFile = event.target.files[0];
        setFile(uploadedFile);
        if (uploadedFile) {
            const fileExtension = getFileExtension(uploadedFile.name);
            const incorrectFileExtension = ["xls", "xlsx", "csv"].indexOf(fileExtension) === -1;
            setIncorrectFileExtension(incorrectFileExtension);
            setIsBadFile({ isBadFile: incorrectFileExtension });
            setUploadLimitExceeded({ uploadLimitExceeded: false });
        }
    };

    return (
        <>
            {/* Starter Moved - mainWrapper - down */}
            {/* Foundation - rowWrapper */}
            <StyledWrapper {...styles.rowWrapper}>
                {uploadCancelled && (
                    /* Starter Custom Code */
                    <InfosBox {...styles.cancelMessage} data-test-selector="OrderUpload_CancellationSuccessful">
                        {siteMessage("OrderUpload_CancellationSuccessful")}
                    </InfosBox>
                    /* Starter Custom Code */
                )}
                <StyledWrapper {...styles.mainWrapper}>
                    <Typography as="p" {...styles.uploadLinkTooltipText}>
                        {descriptionText}
                    </Typography>
                    <Button {...styles.downloadTemplateButton} onClick={downloadTemplateHandler}>
                        {translate("Download Template")}
                    </Button>
                </StyledWrapper>
            </StyledWrapper>
            {/* Foundation - rowWrapper */}
            <StyledWrapper {...styles.rowWrapper}>
                <FileUpload
                    {...styles.fileUploader}
                    inputRef={fileUploadRef}
                    fileName={file?.name || ""}
                    accept=".xls,.xlsx,.csv"
                    label={translate("Upload a File")}
                    labelPosition="top"
                    error={incorrectFileExtension ? translate("must be .xls, .xlsx or .csv") : undefined}
                    onFileChange={fileChangeHandler}
                    uid="orderUploadFileUpload"
                    hideButton={!!file?.name}
                />
                <Checkbox
                    {...styles.includeFirstRowCheckbox}
                    onChange={firstRowHeadingChangeHandler}
                    checked={firstRowHeading}
                    uid="includeHeading"
                    data-test-selector="orderUpload_includeHeading"
                >
                    {/* Foundation Custom Translate */}
                    {translate("Include First Row as Heading")}
                </Checkbox>
            </StyledWrapper>

            {/* Store Custom Code - added the ability to override form action styles */}
            <FormActions {...styles.formActions} /* Starter Custom Code */>
                <Button
                    {...styles.uploadFileButton}
                    disabled={!file || isUploading}
                    onClick={uploadFileHandler}
                    data-test-selector="orderUpload_UploadFile"
                    isLoading={isUploading} // Starter Custom Code
                >
                    {translate("Upload File") /* Starter Custom Code */}
                </Button>
                <Button
                    {...styles.cancelUploadButton}
                    onClick={cancelUploadingHandler}
                    disabled={!isUploading || !allowCancel || uploadCancelled}
                    data-test-selector="orderUpload_CancelUpload"
                >
                    {translate("Cancel Upload")}
                </Button>
            </FormActions>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderUpload);
